import { CpPlansConsentsInterface } from '../../../../interfaces/dto/client-portal/consents/consents-interface';

export class CpPlansConsentsModal implements CpPlansConsentsInterface {
  id: number = 0;
  minAge: number = 0;
  requiredForSubscriptions: boolean = false;
  resume: string = '';
  htmlText: string = '';

  constructor(init?: Partial<CpPlansConsentsModal>) {
    Object.assign(this, init);
  }
}
